import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../components/ui';
import { Home, AlertTriangle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center max-w-md"
      >
        <div className="w-24 h-24 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-8">
          <AlertTriangle className="w-12 h-12 text-primary" />
        </div>
        <h1 className="font-heading text-6xl text-primary mb-4">404</h1>
        <h2 className="font-heading text-2xl text-foreground mb-4">{t('notFound.title', 'Page Not Found')}</h2>
        <p className="text-muted-foreground mb-8">
          {t('notFound.desc', 'The page you are looking for does not exist or has been moved.')}
        </p>
        <Link to="/">
          <Button className="inline-flex items-center gap-2">
            <Home className="w-4 h-4" />
            {t('notFound.home', 'Back to Home')}
          </Button>
        </Link>
      </motion.div>
    </div>
  );
};

export default NotFound;
